module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-02.55848dc4.png";